import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import {
  BoardingStateEnum,
  IPassengerInfo,
  passengerBoardedComputed,
  useFormats,
} from "@ryde/shared";

import { FramerTooltip } from "../tooltips";
import { RideBoardingIndicatorStyled } from "./ride.controls.styled";

interface IRideBoardingIndicator {
  passenger: IPassengerInfo;
}

export const RideBoardingIndicator: FC<IRideBoardingIndicator> = ({
  passenger,
}) => {
  const { t } = useTranslation();
  const { formatDateTimeNormalized } = useFormats();
  const status = passengerBoardedComputed(passenger);

  const tooltipContent = useMemo(() => {
    switch (status) {
      case BoardingStateEnum.Boarded:
        return t("ride.BOARDING_STATUS.Boarded", {
          boardedAt: formatDateTimeNormalized(passenger.boardedAt),
        });
      case BoardingStateEnum.NotBoarded:
        return t("ride.BOARDING_STATUS.NotBoarded");
      default:
        return t("ride.BOARDING_STATUS.Unknown");
    }
  }, [formatDateTimeNormalized, passenger.boardedAt, status, t]);

  return (
    <RideBoardingIndicatorStyled>
      <FramerTooltip content={tooltipContent}>
        <>
          {(!status || status === BoardingStateEnum.Unknown) && (
            <SVG_MUI.BoardingIndicatorSVG data-e2e="boarding-state-unknown" />
          )}
          {status === BoardingStateEnum.Boarded && (
            <SVG_MUI.BoardingIndicatorBoardedSVG data-e2e="boarding-state-boarded" />
          )}
          {status === BoardingStateEnum.NotBoarded && (
            <SVG_MUI.BoardingIndicatorNotBoardedSVG data-e2e="boarding-state-not-boarded" />
          )}
        </>
      </FramerTooltip>
    </RideBoardingIndicatorStyled>
  );
};
